import { render, staticRenderFns } from "./BestFitText.vue?vue&type=template&id=6e38e2f2&scoped=true&"
import script from "./BestFitText.vue?vue&type=script&lang=js&"
export * from "./BestFitText.vue?vue&type=script&lang=js&"
import style0 from "./BestFitText.vue?vue&type=style&index=0&id=6e38e2f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e38e2f2",
  null
  
)

export default component.exports